import React from 'react';

import { useDeleteOrganization } from '../../../presenter/Organization';
import {
  DialogText,
  DialogTitle,
  PrimaryButton,
  TextButton,
} from '../../../ui';
import { ModalDialog, DELETE_ORGANIZATION } from '../../Dialogs';
import { useStyles } from './useStyles';

export const DeleteOrganization: React.FC = () => {
  const { name, onSuccess, onCancel } = useDeleteOrganization();
  const { primaryButton } = useStyles();

  return (
    <ModalDialog id={DELETE_ORGANIZATION}>
      <DialogTitle>Delete organization</DialogTitle>
      <DialogText>Do you really want to delete {name} organization?</DialogText>
      <PrimaryButton fullWidth onClick={onSuccess} className={primaryButton}>
        Delete organization
      </PrimaryButton>
      <TextButton onClick={onCancel}>Cancel</TextButton>
    </ModalDialog>
  );
};
